'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var AllowedCustomOpts = {
  MEETING_SIDEBAR: 'MEETING_SIDEBAR',
  SALES_EXTENSION_SIDEBAR: 'SALES_EXTENSION_SIDEBAR',
  LIVECHAT_SIDEBAR: 'LIVECHAT_SIDEBAR',
  LEADFLOWS_SIDEBAR: 'LEADFLOWS_SIDEBAR',
  FORMS_SIDEBAR: 'FORMS_SIDEBAR',
  DOCUMENTS_SIDEBAR: 'DOCUMENTS_SIDEBAR',
  CRM_EMAIL_SIDEBAR: 'CRM_EMAIL_SIDEBAR',
  MARKETING_FREE_EMAIL_SIDEBAR: 'MARKETING_FREE_EMAIL_SIDEBAR',
  SKIP_SETUP: 'SKIP_SETUP',
  TESTIMONIAL_SIDEBAR: 'TESTIMONIAL_SIDEBAR'
};

exports.default = AllowedCustomOpts;
module.exports = exports['default'];